import React from "react";
import styled from "styled-components";

export default styled.div`

    display: none;
    padding: 20px; 
    
    // height: calc(100vh - 70px);
    height: calc(100vh - 177px);
    overflow-y: scroll;
    padding-top: 6px;
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;
